import styled, { css } from 'styled-components'
import { desktop } from 'ui/src/css'
import { giphyBlack, giphyLightGrey } from '@giphy/colors'
import React from 'react'

const NonHighlight = styled.span`
    color: ${giphyLightGrey};
`

const Word = styled.span`
    ${desktop(css`
        color: ${giphyBlack};
    `)}
`

export function getMatch(term: string, item: string) {
    if (!term) return <NonHighlight>{item}</NonHighlight>
    const lowerTerm = term.toLowerCase()
    const lowerItem = item.toLowerCase()
    if (lowerItem.indexOf(lowerTerm) === 0) {
        return (
            <>
                <Word>{item.slice(0, term.length)}</Word>
                <NonHighlight>{item.slice(term.length)}</NonHighlight>
            </>
        )
    } else {
        return <NonHighlight>{item}</NonHighlight>
    }
}

export const SearchSuggestionItem: React.FC<{
    term: string
    item: string
    highlighted?: boolean
    className?: string
    onClick?: () => void
    onMouseDown?: () => void
    onMouseEnter?: () => void
}> = ({ term, item, highlighted, className, onClick, onMouseDown, onMouseEnter }) => {
    // eslint-disable-next-line no-console
    console.log('[SearchSuggestionItem]', { term, item, highlighted })
    return (
        <div
            className={className}
            style={{ fontWeight: highlighted ? 700 : 600 }}
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseEnter={onMouseEnter}
        >
            {getMatch(term, item)}
        </div>
    )
}
